<template>
    <div v-show="FormInputs.NonProfitOrganizationDetails" class="col-lg-12 col-md-12 col-sm-12 col-sm-12">
        <div class="registration-title">
            Non-Profit Organization Details
        </div>
        <p>Please answer the following questions about your non-profit organization.</p>
        <p class="nonProfit_order">Are you considered a Covered Entity under HIPAA classifications?*
            <span v-tooltip.top="{ html: 'tooltipContent', class: 'custom-tooltip' }"><i class="fa fa-question-circle-o"></i></span></p>
            <div id="tooltipContent" v-html="hipaaTooltip">
            </div>
        <div class="radio g-px-20">
            <label>
                <input type="radio" v-on:click="Account.IsCoveredUnderHIPAA = true" name="IsCoveredUnderHIPAA"> Yes
            </label>
        </div>
        <div class="radio g-px-20">
            <label>
                <input type="radio" v-on:click="Account.IsCoveredUnderHIPAA = false"  name="IsCoveredUnderHIPAA"> No
            </label>
        </div>
        <p class="error-message" v-if="AccountValidationResult.AccountIsCoveredUnderHIPAA">{{AccountValidationResult.AccountIsCoveredUnderHIPAA}}</p>

        <p class="nonProfit_order">Do you, as the non-profit organization, plan to enter orders for glasses, or do you refer cases to eye doctors who order and dispense glasses independently?*</p>
        <div class="radio g-px-20">
            <label>
                <input type="radio" v-model="Account.OrderPlan" value="1" name="OrderPlan"> Non-Profit places orders for glasses
            </label>
        </div>
        <div class="radio g-px-20">
            <label>
                <input type="radio" v-model="Account.OrderPlan" value="2" name="OrderPlan" v-on:click="ShowModal()"> Eye Doctors place orders for glasses
            </label>
        </div>
        <p class="error-message" v-if="AccountValidationResult.AccountOrderPlan">{{AccountValidationResult.AccountOrderPlan}}</p>

        <div v-if="isModalShown">
            <div class="modal-mask" role="dialog">
                <div class="overlay-mask">
                    <div class="modal-dialog modal-md g-mt-100">
                        <div class="modal-content">
                            <div class="modal-body">
                                <div class="close_btn" v-on:click="CloseModal()"></div><br>
                                <div class="passwordReset-header">
                                    <p class="nonprofit-modal-msg">
                                        The non-profit may not need to register for an account. Eye doctors that are part of referral 
                                        networks should register for their own accounts.
                                    </p>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                                    <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-px-30 g-font-size-18" v-on:click="CloseModal()">Confirm</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</template>
<script>
import Vue from 'vue';
import Tooltip from 'vue-directive-tooltip';
import 'vue-directive-tooltip/css/index.css';
Vue.use(Tooltip);
export default {
    props: ['Account', 'AccountValidationResult', 'FormInputs'],
    data() {
        return {
            isModalShown: false
        }
    },
    methods: {
        ShowModal() {
            document.body.classList.add("body-overflow");
            this.isModalShown = !this.isModalShown;
        },
        CloseModal() {
            this.isModalShown = false;
            document.body.classList.remove("body-overflow");
        }
    }
}
</script>


// WEBPACK FOOTER //
// NonProfitOrganizationDetails.vue?e4f21464